// Web version - no offline functionality on web
export const useTrackOfflineStatus = () => {
  // On web, offline functionality is not supported
  return {
    isOffline: false,
    isDownloaded: false,
    downloadProgress: 0,
  };
};
// Web version - no offline functionality on web
export const useTrackIndividualOfflineStatus = () => {
  // On web, offline functionality is not supported
  return 'not_downloaded';
};
